// @ts-ignore the export exists and works, it's just not recognized by TS
import { SafeString } from '@ember/-internals/glimmer';
import { assert } from '@ember/debug';
export let ErrorType = /*#__PURE__*/function (ErrorType) {
  ErrorType["Tooltip"] = "tooltip";
  ErrorType["Message"] = "message";
  return ErrorType;
}({});
export function mapErrorsToStrings(errors) {
  return errors.map(error => {
    assert('errors must be objects with property "message" or strings', typeof error !== 'string' && !(error instanceof SafeString) && (typeof error.message === 'string' || error.message instanceof SafeString) || typeof error === 'string' || error instanceof SafeString);
    if (typeof error === 'string' || error instanceof SafeString) {
      return error;
    }
    return error.message;
  });
}
export function errorsArrayToString(errors) {
  return mapErrorsToStrings(errors).join(' ');
}